/**
 * Colors
 */

// primary
export const primary = "#f03f55";
// used in date and time picker background
export const primaryRGB = `rgba(94.1,24.7,33.3,0.8)`;
// used on a few buttons and card components
export const primaryDark = `#c12a3d`;
// editor keyboard shortcuts alternating links?
export const primaryLight = `rgba(236,63,85,.5)`;

// secondary
export const secondary = `#333e54`;
// various borders and backgrounds
export const secondaryDark = `#2c3144`;
// control room monitors and toolbad
export const tertiaryDark = `#313131`;
// create replay and media player
export const replayBackground = `#2D364A`;
// various backgrounds and borders
export const secondaryLight = `#36425c`;
export const secondaryLighter = `#7E8BB5`;
// select input background and home stream card
export const tertiaryLighter = `#505050`;

// primary text
export const text1 = `#596281`;
// lighter primary text
export const text2 = `#505050`;
// white
export const text3 = `#fff`;
// light gray: borders, disables, empty states
export const text4 = `#a3a8b4`;
// blue: multi-toggle, epg inline calendar, connect page
export const text5 = `#597aaf`;
// orange: stream related, editor transcriber, producer asset list, source overlay
export const text6 = `#f09d12`;
// off-white: various plaves
export const text7 = `#d8d8d8`;
// black: various places producer, components, home screen
export const text8 = `#000000`;
// gray: ingest modal, inputs with character counter, uploader
export const text9 = `#808080`;
// green: password strength, stream settings (ok)
export const text10 = `#00B187`;
// producer asset list, select input
export const text11 = secondaryDark;
// off-white: unused?
export const text12 = `#E1E0FF`;
//blue: overlay text in LC
export const text13 = `#9aa4c6`;
// dark navy: used in trimmer custom markers
export const text14 = `#b2b9d3`;

// disabled text, disabled button state
export const textDisabled = `#BABABA`;
// placeholder text in various places
export const textPlaceholder = `#d8d8d8`;

// input/textarea, editor custom markers
export const inputText = `#505050`;
export const inputOutline = `#e8e8e8`;

// white: everywhere
export const background = `#fff`;
// off-white: everywhere
export const backgroundGrey = `#f7f7f7`;
// home page stream details modal
export const backgroundMidGrey = `#808080`;
// button/calendar
export const backgroundDarkGrey = `#909090`;
// calendar, input, select, various modals
export const backgroundGreySecondary = `#f0f0f0`;
// control room sidebar asset, page header, date picker
export const backgroundHighlight = `#eff1fd`;
// select, control room sidebar asset
export const backgroundFaded = `#d7d7d7`;
// various places
export const outline = `#e8e8e8`;
// input character counter, position grid, calendar
export const outlineDark = `#cfcfcf`;
// input character counter, position grid, time input, tag picker
export const outlineBorder = `#d0d0d0`;
// unused ?
export const outlineLight = `#e0e0e0`;
// select, producer monitor and monitoring links
export const outlineSidebar = `#b2b9d3`;
// epg modal inline calendar
export const overlay = `#eaeef3`;
// unused ?
export const backgroundHoverGrey = `#68708b`;
// editor timeline
export const backgroundLightBlack = `#1A1D29`;
// input with charcount, share history sidebar, date picker
export const disabledGrey = `#d6d6d6`;
// red card background
export const backgroundError = `#F7EDED`;

// uploader, progress bar, producer asset loading
export const pending = `#00e3ad`;
// uploader
export const pendingSecondary = `#d6f6ea`;
// uploader, broadcast, platform users
export const waiting = `#ff9f02`;
// uploader
export const waitingSecondary = `#ffc25d`;
// uploader
export const invalidSecondary = `#f9d7d9`;
// platform users
export const valid = text10;
// social label, adbreak countdown
export const warning = `#ffc461`;

// Potentially part of the new design system, used in Producer Gateway
export const backgroundWarning = `#fef5e5`;

// mutliviewer, editor timeline, audiomixer select
export const editorSectionOutline = `#C9DAF8`;

// color picker input
export const transparency = `linear-gradient(45deg, #aaa 25%, transparent 25%, transparent 75%, #aaa 75%, #aaa), linear-gradient(45deg, #aaa 25%, transparent 25%, transparent 75%, #aaa 75%, #aaa)`;
// input month period select
export const transparent = `transparent`;

// nav sidebar, connect, timmer custom marker
export const primaryIcon = `#505050`;
// various places
export const primaryBackground = `#fff`;
// various places
export const primaryBorder = `#e8e8e8`;
// select, date/time picker, stream schedule
export const primaryText = `#505050`;
// various inputs, controls
export const defaultText = `#596281`;
// iso recording
export const secondaryText = secondaryLighter;
// iso-recording
export const headingText = defaultText;
// cards, context menu, item select, asset list
export const cardBackground = `#fff`;
export const cardBoxShadow = `0px 1px 1px 0 rgba(100 ,100 ,100 , 0.1);`;
export const cardBoxShadowHover = `0px 2px 4px 1px rgba(54, 66, 92, 0.1)`;
// tag picker, producer sidebar card item
export const cardLabelColor = `rgba(51,62,84,.3)`;
// unused ?
export const cardTitleColor = text8;
// nav, producer asset selection
export const tabbedIcon = `#2c3144`;
// nav sidebar, iso-recording
export const tabbedNavBackground = `#f0f0f0`;
export const tabbedItemBackground = `#fff`;
// page header, color picker
export const assetBodyBackground = `#f0f0f0`;
// button, ovp modal
export const hoverColour = `#fff`;
// producer, keyboard modal
export const secondaryHoverColor = `#e5e5e5`;
export const secondaryBackground = `#f0f0f0`;
// automation, home page cards
export const tertiaryBorder = secondaryBackground;
// producer, keyboard modal
export const tertiaryBackground = `#f7f7f7`;
// textarea, color picker, text input, page header, trimmer custom markers
export const dropdownBackground = `#fff`;
export const disabledBackground = `#f2f2f2`;
// nav sidebar, various random places
export const secondaryBorder = `#e8e8e8`;
// icon? looks broken
export const secondaryIcon = `#01c99a`;
// mome stream modal
export const disabledIcon = `#AFAFAF`;
// nav sidebar, producer control room replay
export const sidebarHeaderColour = `#596281`;
// asset list, automation, input searchbar, multi-viwer, trimmer
export const illustrationText = `#596291`;
// producer control room sidebar assets
export const gradient = {
    processing: `linear-gradient(to right, #fff 35%, #ff9f02 50%, #fff 65%);`
};
// unused ?
export const selectizeValue = `#596281`;
// unused ?
export const dropdownBorder = background;
// uploader, tiled select
export const uploadBackground = `#FAFAFA`;
// page header
export const headerBackground = `fff`;
// unused ?
export const headerDropdownText = text1;
// keyboard modal
export const keyBackground = `#404060`;
export const keyBorder = `#75cfe3`;
export const shiftKeyBorder = `#ef3e56`;
export const ctrlKeyBorder = `#35bb93`;
// control room monitors
export const videoBackgroundPattern = `repeating-linear-gradient(-45deg,transparent,transparent 3px,#2a2a2a 1px,#2a2a2a 4px), repeating-linear-gradient(45deg,transparent,transparent 3px,#2a2a2a 1px,#2a2a2a 4px)`;
// button, date picker month period selection
export const primaryButtonText = `#fff`;
// page header
export const headerDivider = `#5F6888`;
export const headerBottomBorder = `rgb(151, 151, 151, 0.25)`;
export const headerDarkBottomBorder = `#1D2039`;
// keyboard shortcuts, stream details modal
export const textOnBlue = `#a3a8b4`;
// producer replay, keyboard shortcuts
export const sidebarBorder = `#B2B9D3`;
// stream modal, producer add live source
export const verticalDivider = `#ADB2BB`;
// producer replay timeline
export const timeDisplayText = headerDivider;
// context menu
export const contextMenuItem = {
    border: secondaryBorder,
    hoverBackground: outline,
    text: backgroundHoverGrey
};
export const contextMenu = {
    border: outline,
    boxShadow: `0px 4px 8px 1px rgba(0, 0, 0, 0.15)`
};
// checkbox input, some nested background color
export const toggleSwitch = `#fff`;
// producer replay player
export const playerControls = text8;

// button
export const button = {
    disabledBg: `#e8e8e8`,
    disabledBorder: `#d7d7d7`,
    disabledText: `#bababa`
};

// home stream card
export const status = {
    offline: `#BABABA`,
    online: `#00E3AD`,
    stopping: `#F09D12`,
    starting: `#F09D12`,
    retrying: `#F09D12`,
    error: `#A94442`,
    disabled: `#BABABA`
};

/*
	Need better names for these colours - currently used around Producer Monitors.
*/
// unused ?
export const monitorBackground = `#313131`;
// unused ?
export const primaryTransparent = `rgba(0, 0, 0, 0)`;
// various small bits
export const producerBackground = `#000`;
// nav sidebar
export const producerBodyBackground = tertiaryBackground;
// nav sidebar, select input
export const producerMainContentBackground = `#333e54`;
// producer monitor split
export const gutterHorizontalBackground = `linear-gradient(
	90deg,
	${primaryTransparent},
	${primaryTransparent} 45%,
	${producerBackground} 0,
	${producerBackground} 55%,
	${primaryTransparent} 0,
	${primaryTransparent}
)`;
export const gutterVerticalBackground = `linear-gradient(
	180deg,
	${monitorBackground},
	${monitorBackground} 60%,
	${producerBackground} 0,
	${producerBackground}
)`;

// pop-out player
export const detachableMonitorBackground = `#1f1f1f`;
export const detachableMonitorHeaderBackground = `#2c3144`;

// producer staging
export const inPreview = `#00e3ad`;
export const inPreviewOff = `#003629`;
export const inProgram = primary;
export const inProgramOff = `#500C14`;
// producer clean feed
export const inClean = `skyblue`;
export const producerSidebarSubviewDivider = textDisabled;
// page header
export const userDropdownProfileBackground = secondaryDark;
export const preferencesIconFocusColor = primaryText;
export const lightOutline = outline;
// producer aspect ratio cropping grid
export const hoverIconButtonBackground = primaryDark;
export const activeIconButtonBackground = primary;

// TODO: dark theme has these defined as extras adding it here as stub for typing purposes
export const primaryLabel = ``; //custom markers + replay?
export const toolbarOverlay = ``; //multi-viwer toolbar

// AI colours
export const aiColor1 = `#000046`;
export const aiColor2 = `#2e0097`;
export const aiColor3 = `#5b00fa`;
export const aiColor4 = `#d300ff`;
export const aiColor5 = `#f03f55`;
